import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'
import i18next from 'i18next'

import { getEventParticipants } from '../../services/contactsService'

const badgeRole = (escape, contact) => {
  const cssClass = contact?.role_code === 'client' ? 'bg-info' : 'bg-secondary'
  return contact?.role_label ? `<span class="ms-1 badge ${cssClass}">${escape(contact?.role_label)}</span>` : ''
}

// Connects to data-controller="events--form"
export default class extends Controller {
  static targets = ['selectPerson', 'lat', 'lon', 'weather']
  static values = { projectId: String }

  connect() {
    this.selectPersonsSetup()
    this.askForLocationAndPopulate()
  }

  disconnect() {
    this.selectPersons.destroy();
  }

  askForLocationAndPopulate() {
    if (this.hasGeolocationData() || !navigator.geolocation) return

    navigator.geolocation.getCurrentPosition(async ({ coords: { latitude, longitude } }) => {
      fetch(`/events/weather?lat=${latitude}&lon=${longitude}`, { method: 'GET' })
        .then(res => res.json())
        .then(({ coord: { lat, lon }, weather: weatherData }) => {
          this.weatherTarget.value = weatherData.map(w => w.description).join(', ')
          this.latTarget.value = lat
          this.lonTarget.value = lon
        })
        .catch((err) => {
          console.error('Error fetching weather data', err)
        })
    })
  }

  hasGeolocationData() {
    return this.latTarget.value?.length && this.lonTarget.value?.length && this.weatherTarget.value?.length
  }

  selectPersonsSetup() {
    this.selectPersons = new TomSelect(this.selectPersonTarget, {
      plugins: ['remove_button'],
      preload: true,
      load: async (search, callback) => {
        const data = await getEventParticipants(this.projectIdValue, search)
        callback(data.participants)
      },
      // onItemAdd: () => {
      //   this.selectPersonTarget.closest('.form-group').querySelector('input[type="select-multiple"]')?.value = ''
      // },
      render: {
        item: (participant, escape) => {
          participant.role_code = participant.role_code || participant.$option.getAttribute('data-role-code')
          participant.role_label = participant.role_label || participant.$option.getAttribute('data-role-label')
          return `<div>${escape(participant.text)}${badgeRole(escape, participant)}</div>`
        },
        option: (participant, escape) => {
          return `<div>${escape(participant.text)}${badgeRole(escape, participant)}</div>`
        },
      },
    })
  }
}
